import { render } from "./ServiceItems.vue?vue&type=template&id=b5680d50&scoped=true"
import script from "./ServiceItems.vue?vue&type=script&lang=js"
export * from "./ServiceItems.vue?vue&type=script&lang=js"

import "./ServiceItems.vue?vue&type=style&index=0&id=b5680d50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5680d50"]])

export default __exports__